import { useOutletContext } from 'react-router-dom';
import ImageHoverPopup from '../../../components/ImageHoverPopup';
import titleCaseString from '../../../utils/titleCaseUtils';
import DateFormatter from '../../../utils/dateFormatterUtils';
import { Skeleton } from '@mui/material';

const PageAccountInfo = ()=> {


    const {details,isLoading} = useOutletContext();
    console.log("detailsx",details);


    return (
        <div className="card card-action mb-4">
            <div className="card-header">
                <div className="d-flex mb-3 gap-3">
                    <div>
                        <span className="badge bg-label-primary rounded-2">
                            <i className="bx bx-user bx-md" />
                        </span>
                    </div>
                    <div>
                        <h4 className="mb-0">
                            <span className="align-middle">Account Info</span>
                        </h4>
                        <span>Real-time information and list of your activities.</span>
                    </div>
                </div>
            </div>


            
            <div className="card-body">

                <table className="table table-bordered" style={{ borderRadius: 10 }}>
                     <tbody>

                      {(() => {

                        if (isLoading) {
                          const customRow = (
                            <tr key="custom" className="text-center">
                              <td colSpan={2} className="text-center">
                                <div className='d-flex justify-content-center'>
                                  <Skeleton animation="wave" variant="circular"  width={200}  height={200} sx={{ bgcolor: 'grey.200' }} />
                                </div>
                              </td>
                            </tr>
                          );

                          const skeletonRows = Array.from({ length: 10 }).map((_, index) => (
                            <tr key={index}>
                              <td className='text-center' colSpan={2}>
                                <Skeleton animation="wave" variant="text" width="100%" height={20} sx={{ bgcolor: 'grey.200' }} />
                              </td>
                            </tr>
                          ));
                          return [customRow, ...skeletonRows];
                        }

                            return (
                              <>
                                <tr>
                                  <td colSpan={2}>
                                    <div className="d-flex flex-column align-items-center">
                                      {details?.user_profile_photo &&
                                        <img
                                          src={details?.user_profile_photo}
                                          alt={`1st Party`}
                                          style={{ cursor: "pointer", maxHeight: 250, objectFit: "cover" }}
                                          className="rounded-pill shadow hover-zoom "
                                          height={200} width={200}
                                        />
                                      }
                                    </div>
                                  </td>
                                </tr>

                                <tr>
                                  <td width={"50%"}> <i className="bx bx-edit" /><span className="fw-medium mx-2">Full Name:</span> </td>
                                  <td className="fw-bold">Atty.{' '}
                                    {titleCaseString(
                                      (details?.first_name +
                                        (details?.middle_name ? ' ' + details?.middle_name : '') +
                                        ' ' +
                                        details?.last_name +
                                        (details?.suffix ? ' ' + details?.suffix : '')
                                      )
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-toggle-left" /><span className="fw-medium mx-2">Status:</span> </td>
                                  <td className="fw-bold">
                                    {(() => {
                                      const status = details?.user_status?.toUpperCase();
                                      const badgeClass =
                                        status === "VERIFIED" ? "bg-label-info" :
                                          status === "PENDING" ? "bg-label-warning" :
                                            "bg-label-danger";

                                      return (
                                        <span className={`badge ${badgeClass} me-1`}>
                                          {status}
                                        </span>
                                      );
                                    })()}
                                  </td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-calendar-check" /><span className="fw-medium mx-2">Date Joined:</span> </td>
                                  <td className="fw-bold">{details?.date_created}</td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-calendar-alt" /><span className="fw-medium mx-2">Birthday:</span> </td>
                                  <td className="fw-bold">{details?.birth_date}</td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span> </td>
                                  <td className="fw-bold">{titleCaseString(details?.gender?.toUpperCase())}</td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-group" /><span className="fw-medium mx-2">Civil Status:</span> </td>
                                  <td className="fw-bold">{titleCaseString(details?.civil_status?.toUpperCase())}</td>
                                </tr>

                                <tr>
                                  <td><i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span></td>
                                  <td className="fw-bold">{details?.mobile_number}</td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span> </td>
                                  <td className="fw-bold">{details?.email}</td>
                                </tr>

                                <tr>
                                  <td><i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span> </td>
                                  <td> {details?.signature && <ImageHoverPopup imageSrc={details?.signature} altText="Signature" height={30} label="SIGNATURE" />} </td>
                                </tr>

                                <tr>
                                  <td> <i className="bx bx-current-location" /><span className="fw-medium mx-2">Address:</span> </td>
                                  <td className="fw-bold">{details?.region} {details?.province} {details?.municipality} {details?.barangay}</td>
                                </tr>

                              </>
                            )
                          })
                        ()
                      }
                    </tbody>
                </table>


               
 

            </div>

          


        </div>
    );
}
 
export default PageAccountInfo;